import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('KYS/GetList', { params });
  },
  getDetail(_, id) {
    return axios.get('KYS/GetDetail', { params: { id } });
  },
  approve(_, id) {
    return axios.get('KYS/Approve', { params: { id } });
  },
  save(_, form) {
    return axios.post('KYS/save', form);
  },
  saveWithFile(_, formData) {

    return axios.post('KYS/SaveWithFile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  delete(_, id) {
    return axios.get('KYS/Delete', { params: { id } });
  },
  getStatusList(_, params) {
    return axios.get('KYS/GetStatusList', { params });
  },
};
